// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, View } from "@components";
import classNames from "classnames";
import type { ReleaseNote } from "@modules/shared/selectors";
type Props = {
  ...PropsFromLocalize,
  onClose: () => void,
  onClick: () => void,
  releaseNote: ReleaseNote | null,
};

function NewReleaseNoteModal(props: Props) {
  return (
    <Modal rightPanel width="340px" onToggle={props.onClose}>
      <ModalHeader className="d-flex justify-content-between">
        {props.t("NEW_RELEASE_NOTES_TITLE")}
      </ModalHeader>
      <ModalBody>
        <View gap={3}>
          <View>
            {props.t("NEW_RELEASE_NOTES_TEXT", {
              version: props.releaseNote?.version,
            })}
          </View>
          <View
            key={props.t("LATEST_RELEASE_NOTES")}
            className={classNames("cursor-pointer gs-card medium")}
            onClick={props.onClick}
          >
            <View
              flex={3}
              backgroundSize="cover"
              backgroundImage={"/assets/img/ReleaseNotes.jpg"}
            />
            <View flex={1} padding={2}>
              <h6>{props.t("LATEST_RELEASE_NOTES")}</h6>
            </View>
          </View>
          <div>
            <Button onClick={props.onClose} className="float-left">
              {props.t("DISMISS")}
            </Button>
          </div>
        </View>
      </ModalBody>
    </Modal>
  );
}

export default localize()(NewReleaseNoteModal);
